import { useDispatch } from 'react-redux'
import type { AppDispatch } from '@app-types/general'

// export a typed useDispatch hook
export const useAppDispatch: () => AppDispatch = useDispatch
